import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import SearchBar from '../../components/searchBar';
import Table from '../../components/table';
import messages from '../../text/messages';
import { getClientsProjects, saveProject, removeProject } from '../../reducers/projects';
import AddProject from './addProject';

class ProjectsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchString: ''
        };

        this.onSave = this.onSave.bind(this);
        this.onRemove = this.onRemove.bind(this);
    }

    componentDidMount() {
        const { role, getClientsProjects } = this.props;
        getClientsProjects(role.id);
    }

    onSave(values) {
        const colors = ['#75a535', '#7477C8', '#E28E8E', '#3e5bfe', '#3ef4fe'];
        const { role, saveProject, getClientsProjects, projects } = this.props;
        const color = values.id ? values.color : colors[projects.length % colors.length];

        saveProject({ ...values, client_id: role.id, color }, () => getClientsProjects(role.id));
    }

    onRemove(projectId) {
        const { role, removeProject, getClientsProjects } = this.props;
        removeProject(projectId, () => getClientsProjects(role.id));
    }

    getColumnDefinition() {
        return [
            {
                label: <FormattedMessage {...messages.name} />,
                valueMap: project => (
                    <div className="full-height-cell ellipsis">
                        <span className="">{project.name}</span>
                    </div>
                ),
                size: 'col-xs-9 col-sm-3',
                sort: (a, b) => a.name.localeCompare(b.name)
            },
            {
                label: <FormattedMessage {...messages.description} />,
                valueMap: project => (
                    <div className="full-height-cell ellipsis">
                        <span className="">{project.description}</span>
                    </div>
                ),
                size: 'col-xs-3  hidden-xs',
                sort: (a, b) => (a.description || '').localeCompare(b.description || '')
            },
            {
                valueMap: project => (
                    <div className="text-center">
                        <AddProject onSubmit={this.onSave} initialValues={project} onRemove={this.onRemove} />
                    </div>
                ),
                size: 'col-xs-3 col-sm-2'
            }
        ];
    }

    filterResults() {
        const { projects } = this.props;
        const { searchString } = this.state;

        if (!searchString.trim()) {
            return projects;
        }

        let filter = searchString.toLowerCase();
        return projects.filter(e => (e.name || '').toLowerCase().includes(filter) || (e.description || '').toLowerCase().includes(filter));
    }

    render() {
        const { projects } = this.props;
        if (!projects) return null;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <SearchBar onSubmit={d => this.setState({ ...this.state, searchString: d.value })} />
                    </div>
                    <div className="col-sm-6 col-xs-12 add-wrapper">
                        <AddProject onSubmit={this.onSave} />
                    </div>
                </div>
                <div className="col-xs-12">
                    <Table
                        data={this.filterResults()}
                        rowStyle={'gl-table-body-row clickable-row'}
                        columns={this.getColumnDefinition()}
                        keyExtractor={'id'}
                        defaultSortColumn={0}
                    />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, props) => ({
    role: props.clientRole || state.identity.role,
    projects: state.projects.list
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getClientsProjects,
            saveProject,
            removeProject
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsList);



// WEBPACK FOOTER //
// ./src/pages/projects/projectsList.jsx